import { compact, uniq } from 'lodash-es'

export default (text) =>
  uniq(compact(text.split(/[,\s\t\r\n]+/gm).map((x) => x.trim())))
